<p>top-bar-config works!</p>
